import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { compose } from 'recompose';

import { WithStyles, withStyles } from '@/hocs/with-styles';

const styles = (theme: Theme) => ({
  content: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&:first-child': {
      marginTop: 0,
    },
  },
});

interface Properties {}

interface State {}

class TextContentArea extends React.Component<Properties & WithStyles<typeof styles>, State> {
  public render() {
    const { classes, children } = this.props;
    return <div className={classes.content}>{children}</div>;
  }
}

const enhance = compose<unknown, Properties>(withStyles(styles));

export default enhance(TextContentArea as React.ComponentType<unknown>);
